import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceDetailHero from '../components/ServiceDetailHero';
import ServiceDetailContent from '../components/ServiceDetailContent';
import ServiceDetailFeatures from '../components/ServiceDetailFeatures';
import ServiceDetailProcess from '../components/ServiceDetailProcess';
import ServiceDetailPricing from '../components/ServiceDetailPricing';
import CTASection from '../../home/components/CTASection';
import { useSEO } from '../../../utils/seo';

const VideoProductionPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Video Prodüksiyon & Motion Graphics - Sigorta360 | Kurumsal Video Çekimi',
    description: 'Sigorta acenteleri için profesyonel video prodüksiyon ve motion graphics hizmeti. Kurumsal tanıtım filmleri, reel video, animasyon. 8.000₺\'den başlayan paketler.',
    keywords: 'sigorta video çekimi, kurumsal video, reel video, motion graphics, video prodüksiyon',
    canonical: `${siteUrl}/hizmetler/video-produksiyon`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Video Prodüksiyon & Motion Graphics',
      description: 'Profesyonel video prodüksiyon ve motion graphics hizmeti',
      provider: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      },
      areaServed: {
        '@type': 'Country',
        name: 'Türkiye'
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TRY',
        lowPrice: '8000',
        highPrice: '20000',
        offerCount: '3'
      }
    }
  });

  const heroData = {
    category: 'İçerik Üretimi',
    title: 'Video Prodüksiyon & Motion Graphics',
    description: 'Güven veren video içerikler ve motion graphics ile müşterilerinize ulaşın. Kurumsal tanıtım filmlerinden sosyal medya içeriklerine, ürün tanıtımlarından animasyonlara kadar profesyonel video çözümleri.',
    image: 'https://public.readdy.ai/ai/img_res/6bb3bf5dc8d9c09d65b1403835a403f0.jpg',
  };

  const contentData = {
    overview: 'Video içerikler, sigorta sektöründe güven oluşturmanın ve karmaşık konuları basitleştirmenin en etkili yoludur. Sigorta360 olarak, markanızın hikayesini anlatan, müşterilerinizi eğiten ve dönüşüm sağlayan profesyonel video içerikler üretiyoruz.',
    benefits: [
      {
        icon: 'ri-eye-line',
        title: 'Yüksek Etkileşim',
        description: 'Video içerikler, metin ve görsellere göre %1200 daha fazla paylaşılıyor.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Güven İnşası',
        description: 'Yüz yüze iletişim hissi veren videolarla müşterilerinizde güven oluşturun.',
      },
      {
        icon: 'ri-lightbulb-line',
        title: 'Kolay Anlaşılır',
        description: 'Karmaşık sigorta kavramlarını basit ve anlaşılır şekilde anlatın.',
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Dönüşüm Artışı',
        description: 'Video içeren landing page\'ler %80 daha fazla dönüşüm sağlıyor.',
      },
    ],
  };

  const featuresData = {
    title: 'Video Prodüksiyon Hizmetlerimiz',
    features: [
      {
        icon: 'ri-film-line',
        title: 'Kurumsal Tanıtım',
        description: 'Şirket tanıtım filmleri, ekip tanıtımları, ofis turları, marka hikayesi videoları.',
      },
      {
        icon: 'ri-product-hunt-line',
        title: 'Ürün Tanıtımı',
        description: 'Sigorta ürünleri tanıtım videoları, ürün özellikleri, fayda anlatımları, karşılaştırma videoları.',
      },
      {
        icon: 'ri-smartphone-line',
        title: 'Sosyal Medya İçerikleri',
        description: 'Reels, shorts, stories için kısa videolar, trend içerikler, eğitici videolar.',
      },
      {
        icon: 'ri-magic-line',
        title: 'Motion Graphics',
        description: 'Animasyonlu açıklayıcı videolar, infografik animasyonlar, logo animasyonları.',
      },
      {
        icon: 'ri-user-voice-line',
        title: 'Müşteri Referansları',
        description: 'Müşteri röportajları, başarı hikayeleri, testimonial videoları.',
      },
      {
        icon: 'ri-live-line',
        title: 'Canlı Yayın',
        description: 'Webinar yayınları, etkinlik canlı yayınları, soru-cevap oturumları.',
      },
    ],
  };

  const processData = {
    title: 'Video Üretim Sürecimiz',
    steps: [
      {
        number: '01',
        title: 'Ön Prodüksiyon',
        description: 'Konsept geliştirme, senaryo yazımı, storyboard oluşturma, lokasyon ve oyuncu seçimi.',
      },
      {
        number: '02',
        title: 'Prodüksiyon',
        description: 'Profesyonel çekim ekibi, 4K kamera, aydınlatma, ses kayıt, drone çekimleri.',
      },
      {
        number: '03',
        title: 'Post Prodüksiyon',
        description: 'Video kurgu, renk düzeltme, ses düzenleme, müzik ekleme, efekt çalışmaları.',
      },
      {
        number: '04',
        title: 'Revizyon',
        description: 'Geri bildirim alma, gerekli düzeltmeler, final onayı.',
      },
      {
        number: '05',
        title: 'Teslim & Dağıtım',
        description: 'Tüm formatlarda teslim, sosyal medya optimizasyonu, yayınlama desteği.',
      },
    ],
  };

  const pricingData = {
    title: 'İçerik & Video Prodüksiyon Paketleri',
    packages: [
      {
        name: 'Başlangıç',
        price: '8.000',
        period: 'ay',
        description: 'Telefon ve video stoklarla temel montaj',
        features: [
          '2 Reel video üretimi',
          'Temel video montaj ve kurgu',
          'Stok görsel ve video kullanımı',
          'Telefon çekimi desteği',
          'Basit geçiş efektleri',
          'Müzik ve ses düzenleme',
          'Sosyal medya formatları',
        ],
        highlighted: false,
      },
      {
        name: 'Profesyonel',
        price: '13.500',
        period: 'ay',
        description: 'Profesyonel çekim ve hareketli grafikler',
        features: [
          '4 Reel video üretimi',
          'Profesyonel kamera çekimi',
          'Motion graphic animasyonlar',
          'Hareketli grafik tasarımları',
          'Gelişmiş kurgu ve efektler',
          'Profesyonel ses düzenleme',
          'Renk düzeltme ve grading',
          'Çoklu platform optimizasyonu',
        ],
        highlighted: true,
      },
      {
        name: 'Premium',
        price: '20.000',
        period: 'ay',
        description: 'Tam üretim süreci ve profesyonel ekip',
        features: [
          '6 Reel video üretimi',
          'Senaryo yazımı ve planlama',
          'Profesyonel çekim ekibi',
          'Oyuncu ve lokasyon yönetimi',
          'Gelişmiş FX ve animasyonlar',
          'Drone çekimleri',
          'Profesyonel seslendirme',
          'Premium post-prodüksiyon',
        ],
        highlighted: false,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServiceDetailHero data={heroData} />
        <ServiceDetailContent data={contentData} />
        <ServiceDetailFeatures data={featuresData} />
        <ServiceDetailProcess data={processData} />
        <ServiceDetailPricing data={pricingData} />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default VideoProductionPage;
